var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site",class:_vm.classes,style:({
    '--page-link-color': _vm.getTemplateOption('page_link_color'),
    '--page-text-color': _vm.getTemplateOption('page_text_color')
  })},[_c('AppSnackbar'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('ExpandableLineNav'),_vm._v(" "),_c('ExpandableOffCanvasNav',{attrs:{"available-locales":_vm.availableLocales}}),_vm._v(" "),_c('PageContainer'),_vm._v(" "),_c('Footer',{attrs:{"available-locales":_vm.availableLocales}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }